import React, { useState ,useEffect} from "react";
import * as Styles from "../Farmers/components/FarmerForm/style";
import close from "../assets/images/close.png";
import * as Yup from "yup";
import { Formik, Field, FieldArray } from "formik";
import { InputGroup } from "../shared/InputGroup/InputGroup2";
import { SelectGroup } from "../shared/SelectGroup/SelectGroup";
import Select from "react-select";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import Cookies from 'universal-cookie'
import axios from 'axios'

const cookies = new Cookies()
const initialInhiveSensorValues = {
  hiveId: "",
  boardId: "",
  sensorTypes: ["SENSOR001"], // Default all selected
  solarAttached: "yes",
  devBoard: "",
  sensorCommunicationProtocol: ["Bluetooth"],
  macAddress: "",
  batteryLevel: "",
  hiveLocation: "",
  firmwareVersion: "",
  installationDate: new Date().toISOString(),
  status: "active",
};

const inhiveSensorSchema = Yup.object().shape({
  hiveId: Yup.string().required("Hive ID is required"),
  sensorTypes: Yup.array()
    .of(Yup.string())
    .required("At least one sensor type is required"),
  boardId:Yup.string().required("Board ID is required"),
  solarAttached: Yup.string().required("Solar attachment status is required"),
  devBoard: Yup.string().required("Dev board is required"),
  sensorCommunicationProtocol: Yup.array()
    .of(Yup.string())
    .required("At least one communication protocol is required"),
  macAddress: Yup.string().required("MAC address is required"),
  batteryLevel: Yup.number()
    .required("Battery level is required")
    .min(0)
    .max(100),
  hiveLocation: Yup.string().required("Hive location is required"),
  firmwareVersion: Yup.string().required("Firmware version is required"),
  installationDate: Yup.date().required("Installation date is required"),
  status: Yup.string()
    .oneOf(["active", "inactive"], "Invalid status")
    .required("Status is required"),
});

const communicationProtocol = [
  { value: "bluetooth", label: "bluetooth" },
  { value: "wifi", label: "wifi" },
  { value: "GSM", label: "GSM" },
];
const metrics = [
  "temperature",
  "pressure",
  "humidity",
  "co2_gas",
  "audio",
  "image",
  "video",
];

const boardNames = ["esp32_nodemcu", "raspberry_pi_zero_2_w"];
const status = ["active", "inactive"];
const sensorCommunicationProtocols = ["i2s", "spi"];
const yesOrNo = ["yes", "no"];
export const AddSensorTypeForm = (props) => {
  const { handleClose } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hiveId, setinHiveId] = useState( [] );
  const [selectedCommunicationProtocol, setselectedCommunicationProtocol] =
    useState([{ value: "wifi", label: "Wifi" }]);
    const [type, setType] = useState("create");
    const [formdata, setFormData] = useState(initialInhiveSensorValues);

  const [sensorType, setsensorType] = useState([
    {
      value: "SENSOR001",
      label: "Temperature Sensor",
    },
    {
      value: "SENSOR002",
      label: "Humidity Sensor",
    },
    {
      value: "SENSOR003",
      label: "Pressure Sensor",
    },
  ]);
  const [selectedSensorType, setselectedSensorType] = useState([]);
  const [selectedMetrics, setSelectedMetrics] = useState([]);

  const getInHiveSensor =async()=>{
    try {
      const currentToken = cookies.get('access_token')
  
          const  headers= {
            headers:{
              authorization: `Bearer ${currentToken}`,
            }
          }
      const res= await axios.get(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/hives`,headers)
   
      if(res.data)    
      {
        const data=res.data.map(it=>(it.hive_id))
      setinHiveId(data)
    }
    } catch (error) {
      console.log(error);
      toast.error('Error in getting inhive sensors data');
    }}

  useEffect(() => {
    getInHiveSensor()
    if (props.type === "edit") {
      const initialData = props.intialData;
      console.log(initialData);
      const formData2 = {
        hiveId: initialData.hive_id || "",
        devBoard: initialData.dev_board || "",
        macAddress: initialData.mac_address || "",
        batteryLevel: initialData.battery_level || 0,
        hiveLocation: initialData.hive_location || "",
        firmwareVersion: initialData.firmware_version || "",
        installationDate: initialData.installation_date || "",
        lastSeen: initialData.last_seen || new Date().toISOString(),
        solarAttached: initialData.solar_attached ? "yes" : "no",
        boardId: initialData.board_id || "",
        status: initialData.status || "active",
        sensorType:sensorType.filter(sensor => initialData.sensor_types.includes(sensor.value)),
        communicationProtocol: initialData.communication_protocol?.map(it => ({
          value: it,
          label: it
        })) || [], 
      };
      setselectedSensorType(formData2.sensorType)
      setselectedCommunicationProtocol(formData2.communicationProtocol);
      console.log("Form Data (Edit Mode):", formData2, initialData);
      setFormData(formData2);
      setType(props.type);
    }
  }, [])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      if (selectedSensorType.length === 0) {
        toast.error("Please select at least one Sensor Type");
        return;
      }
      if (selectedCommunicationProtocol.length === 0) {
        toast.error("Please select at least one Communication Protocol");
        return;
      }
      if (!values.devBoard.trim()) {
        toast.error("Dev Board cannot be empty");
        return;
      }
      setIsSubmitting(true);
      
      const payload = {
  
        hive_id: values.hiveId,
        dev_board: values.devBoard,
        mac_address: values.macAddress,
        battery_level: values.batteryLevel,
        hive_location: values.hiveLocation,
        firmware_version: values.firmwareVersion,
        installation_date: values.installationDate,
        last_seen: new Date().toISOString(),
        solar_attached: values.solarAttached === 'yes',
        board_id:values.boardId,
        communication_protocol: selectedCommunicationProtocol.map(it => it.value),
        status: values.status,
        board_id: values.boardId ,
        sensor_types:selectedSensorType.map(it => it.value)
      };

      console.log("Payload being sent:", payload);
      const currentToken = cookies.get('access_token')

      const  headers= {
          authorization: `Bearer ${currentToken}`,
          'Content-Type': 'application/json',
      }
      const existingSensor = await fetch(`${process.env.REACT_APP_HUMBLEBEE_API_URL}/sensors/register/inhive-sensor`, {
        method: type=='edit'?'PUT':'POST' ,
        headers: headers,
        body: JSON.stringify(payload),
      });
      if (!existingSensor.ok) {
        const errorData = await existingSensor.json();
        console.error('Error response:', errorData);
        toast.error('Error: Hive Camera not submitted');
        return;
      }

      const result = await existingSensor.json();
      console.log('Success:', result);
      toast.success('Hive Camera submitted successfully');
      resetForm();
      handleClose2()
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose2 = () => {
    handleClose()
  };

  return (

    <Styles.ModalContent>
      <Formik
        initialValues={formdata}
        onSubmit={handleSubmit}
        validationSchema={inhiveSensorSchema}
        validateOnMount
        enableReinitialize
      >
        {(formik) => (
          <Styles.FormWithCloseButton>
            <Styles.CloseButtonDiv>
              <h3>{type=='edit'?'Edit':'Add'}  Sensor Type</h3>
              <Styles.FormCloseButton2 onClick={handleClose2}>
                <img src={close} alt="Close" />
              </Styles.FormCloseButton2>
            </Styles.CloseButtonDiv>

            {/* Main Bode of Form Starts */}
            <Styles.MainFarmerFormDiv>
              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Firmware Version"
                  LabelText="Firmware Version"
                  name="firmwareVersion"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                  value={formik.values.firmwareVersion}
                />
                {/* {console.log(formik.errors, formik.touched)} */}

                <InputGroup
                  PlaceholderText="Enter Dev Board"
                  LabelText="Dev Board"
                  name="devBoard"
                  type="text"
                  star="*"
                  value={formik.values.devBoard}

                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Is Solar Attached"
                  LabelText="Solar Attached"
                  name="solarAttached"
                  value={formik.values.solarAttached}

                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={yesOrNo}
                  star="*"
                />
                <SelectGroup
                  PlaceholderText="Enter Status"
                  LabelText="Status"
                  value={formik.values.status}

                  name="status"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={status}
                  star="*"
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Hive Location"
                  LabelText="Hive Location"
                  value={formik.values.hiveLocation}

                  name="hiveLocation"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />

                <InputGroup
                  PlaceholderText="Enter MAC Address"
                  LabelText="MAC Address"
                  value={formik.values.macAddress}

                  name="macAddress"
                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>

              <Styles.RowFlex>
                <InputGroup
                  PlaceholderText="Enter Battery Level"
                  LabelText="Battery Level"
                  name="batteryLevel"
                  value={formik.values.batteryLevel}

                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
                <InputGroup
                  PlaceholderText="Enter Installation Date"
                  LabelText="Installation Date"
                  name="installationDate"
                  type="date"
                  star="*"
                  value={formik.values.installationDate ? new Date(formik.values.installationDate).toISOString().split("T")[0] : ""}
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>
              <Styles.RowFlex>
                <SelectGroup
                  PlaceholderText="Select Hive Id"
                  LabelText="Hive Id"
                  value={formik.values.hiveId}

                  name="hiveId"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  options={hiveId}
                  star="*"
                />
                 <InputGroup
                  PlaceholderText="Enter Board Id"
                  LabelText="Board Id"
                  name="boardId"
                  value={formik.values.boardId}

                  type="text"
                  star="*"
                  onChange={formik.handleChange}
                />
              </Styles.RowFlex>
              <div
                className="multi-select-group"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <label>Select Sensor Type</label>
                <MultiSelect
                  options={sensorType}
                  value={selectedSensorType}
                  onChange={setselectedSensorType}
                  labelledBy="Select Sensor Type *"
                  hasSelectAll={false}
                />
              </div>
              <div
                className="multi-select-group"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <label>Select Communication Protocol</label>
                <MultiSelect
                  options={communicationProtocol}
                  value={selectedCommunicationProtocol}
                  onChange={setselectedCommunicationProtocol}
                  labelledBy="Select Communication Protocol*"
                  hasSelectAll={false}
                />
              </div>
             
            </Styles.MainFarmerFormDiv>

            {/* Main Body of Form stops */}

            <Styles.CreateFarmerButton type="submit">
              {isSubmitting ? "Submitting..." : type=='edit'? 'Update'  : "Create"}
            </Styles.CreateFarmerButton>
          </Styles.FormWithCloseButton>
        )}
      </Formik>
    </Styles.ModalContent>

  );
};
